import LabelMap from '../../types/label-map/LabelMap';
import __ from '../../i18n';

const REFERENCE_KEY_WATCH_LUG_WIDTH = 'WATCH_LUG_WIDTH';
const REFERENCE_KEY_WATCH_LUGS_DISTANCE = 'WATCH_LUGS_DISTANCE';
const REFERENCE_KEY_WATCH_CASE_DIAMETER = 'WATCH_CASE_DIAMETER';
const REFERENCE_KEY_WATCH_CASE_THICKNESS = 'WATCH_CASE_THICKNESS';
const REFERENCE_KEY_WATCH_CASE_MATERIAL = 'WATCH_CASE_MATERIAL';
const REFERENCE_KEY_WATCH_MOVEMENT_TYPE = 'WATCH_MOVEMENT_TYPE';
const REFERENCE_KEY_WATCH_CRYSTAL = 'WATCH_CRYSTAL';
const REFERENCE_KEY_WATCH_WATER_RESISTANCE = 'WATCH_WATER_RESISTANCE';
const REFERENCE_KEY_WATCH_FEATURES = 'WATCH_FEATURES';
const REFERENCE_KEY_WATCH_GENDER = 'WATCH_GENDER';
const REFERENCE_KEY_STRAP_WIDTH = 'STRAP_WIDTH';
const REFERENCE_KEY_STRAP_MATERIAL = 'STRAP_MATERIAL';
const REFERENCE_KEY_STRAP_BUCKLE_TYPE = 'STRAP_BUCKLE_TYPE';
const REFERENCE_KEY_STRAP_BUCKLE_MATERIAL = 'STRAP_BUCKLE_MATERIAL';
const REFERENCE_KEY_STRAP_BUCKLE_SIZE = 'STRAP_BUCKLE_SIZE';

export default new LabelMap([
    [REFERENCE_KEY_WATCH_LUG_WIDTH, __('Watch: Lug width')],
    [REFERENCE_KEY_WATCH_LUGS_DISTANCE, __('Watch: Lug-to-lug')],
    [REFERENCE_KEY_WATCH_CASE_DIAMETER, __('Watch: Case diameter')],
    [REFERENCE_KEY_WATCH_CASE_THICKNESS, __('Watch: Case thickness')],
    [REFERENCE_KEY_WATCH_CASE_MATERIAL, __('Watch: Case material')],
    [REFERENCE_KEY_WATCH_MOVEMENT_TYPE, __('Watch: Movement type')],
    [REFERENCE_KEY_WATCH_CRYSTAL, __('Watch: Crystal')],
    [REFERENCE_KEY_WATCH_WATER_RESISTANCE, __('Watch: Water resistance')],
    [REFERENCE_KEY_WATCH_FEATURES, __('Watch: Features')],
    [REFERENCE_KEY_WATCH_GENDER, __('Watch: Gender')],
    [REFERENCE_KEY_STRAP_WIDTH, __('Strap: Width')],
    [REFERENCE_KEY_STRAP_MATERIAL, __('Strap: Material')],
    [REFERENCE_KEY_STRAP_BUCKLE_TYPE, __('Strap: Buckle type')],
    [REFERENCE_KEY_STRAP_BUCKLE_MATERIAL, __('Strap: Buckle material')],
    [REFERENCE_KEY_STRAP_BUCKLE_SIZE, __('Strap: Buckle size')],
]);

export {
    REFERENCE_KEY_WATCH_LUG_WIDTH,
    REFERENCE_KEY_WATCH_LUGS_DISTANCE,
    REFERENCE_KEY_WATCH_CASE_DIAMETER,
    REFERENCE_KEY_WATCH_CASE_THICKNESS,
    REFERENCE_KEY_WATCH_CASE_MATERIAL,
    REFERENCE_KEY_WATCH_MOVEMENT_TYPE,
    REFERENCE_KEY_WATCH_CRYSTAL,
    REFERENCE_KEY_WATCH_WATER_RESISTANCE,
    REFERENCE_KEY_WATCH_FEATURES,
    REFERENCE_KEY_WATCH_GENDER,
    REFERENCE_KEY_STRAP_WIDTH,
    REFERENCE_KEY_STRAP_MATERIAL,
    REFERENCE_KEY_STRAP_BUCKLE_TYPE,
    REFERENCE_KEY_STRAP_BUCKLE_MATERIAL,
    REFERENCE_KEY_STRAP_BUCKLE_SIZE,
}
